<template>
  <v-img height="150" contain class="logo" :src="src" :lazy-src="src" :alt="title" :title="title"></v-img>
</template>

<script>
import Tcb from '@/tcb'
export default {
  props: {
    cloudPath: String,
    cover: Boolean,
    transition: String,
    gradient: String
  },
  data: () => ({
    src: '',
    title: ''
  }),
  async created () {
    const res = await Tcb.getTempFileURL({
      fileList: [this.cloudPath]
    })
    if (res.fileList[0].code === 'SUCCESS') {
      this.src = res.fileList[0].tempFileURL
      this.title = res.title
    }
  }
}
</script>
